import Product from "../../../../../@types/Product";

const Tires12In: Product[] = [
    {
        id: 1,
        refId: 12,
        name: '215/50-R12 GTW® Fusion S/R Steel Belted Tire x4',
        sku: '20-063',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/tires/12-inch/gtw-r12-fusion-steel-belted-tire-300x300.jpg`,
        price: 190.00,
        retailPrice: 0.00,
    },
]

const Tires12InLifted: Product[] = [
    {
        id: 2,
        refId: 12,
        name: '22x11-R12 GTW® Nomad Steel Belted Radial DOT Tire x4',
        sku: '20-065',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/tires/12-inch/gtw-r12-nomad-steel-belted-radial-300x300.jpg`,
        price: 190.00, // normally 250.00 but Nivel wanted lift kit price reduction so lowering tires cost as these are only applied to lifted
        retailPrice: 0.00,
    },
]

export { 
    Tires12In, 
    Tires12InLifted, 
}